(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('HxMedicationRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        HxMedicationRepository,
    ]);

    function HxMedicationRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {

        return {
            addPrescription: addPrescription,
            deleteMedication: deleteMedication,
            getMedicationListFilters: getMedicationListFilters,
            getPatientTakesNoMeds: getPatientTakesNoMeds,
            getPrescriptionHistory: getPrescriptionHistory,
            getPrescriptionHistoryForDiscontinueCancel: getPrescriptionHistoryForDiscontinueCancel,
            getTransitionOfCare: getTransitionOfCare,
            setMedicationFilter: setMedicationFilter,
            setPatientTakesNoMeds: setPatientTakesNoMeds,
            setTransitionOfCare: setTransitionOfCare,
            getPatientMedStatus: getPatientMedicationStatus,
            getPatientMedStatuses: getPatientMedicationStatuses,
            discontinueCancelMedications: discontinueCancelMedications,
            isRxOnPatientAllergyList: isRxOnPatientAllergyList,
            getCompareInfoForDiscontinueCancel: getCompareInfoForDiscontinueCancel
        };

        function addPrescription(patientId, visitId, skippedSigwriter, prescription) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'addPrescription');
            var restangular = AprimaRestangular.get();
            var dto = {
                Prescription: prescription,
                SkippedSigwriter: skippedSigwriter,
                VisitId: visitId,
            };
            return restangular
                .all('patients/' + patientId + '/addprescription')
                .post(dto)
                .finally(timing.stop);
        }

        function deleteMedication(medication, visitId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'deleteMedication');
            return AprimaRestangular.get()
                .one('history/visit', visitId)
                .one('medication', medication.RelPatientMedicationUid)
                .remove()
                .finally(timing.stop);
        }

        function getMedicationListFilters(subtype) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getMedicationListFilters');
            var queryString = '?subtype=' + subtype;
            return AprimaRestangular.get()
                                    .one('history/rx-filters' + queryString)
                                    .get()
                                    .finally(timing.stop);
        }
        
        function setMedicationFilter(setMedicationFilterDto) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'setMedicationFilter');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('history/rx-filter')
                .post(setMedicationFilterDto)
                .finally(timing.stop);
        }

        function getPatientTakesNoMeds(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getPatientTakesNoMeds');
            var restangular = AprimaRestangular.get();
            var params = {
                VisitId: visitId,
            };
            return restangular
                .one('patients/' + patientId + '/patienttakesnomeds')
                .get(params)
                .finally(timing.stop);
        }

        function getPrescriptionHistory(patientId, visitId, filterId) {
            var timing = AprimaAnalytics.startTiming('FncRxRepository', 'api', 'getPrescriptionHistory');
            var restangular = AprimaRestangular.get();
            var params = {
                FilterId: filterId,
                VisitId: visitId,
            };
            return restangular.one('patients/' + patientId  + '/rx-history')
                              .get(params)
                              .finally(timing.stop);
        }

        function getPrescriptionHistoryForDiscontinueCancel(patientId, visitId, relPatientMedicationIds) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getPrescriptionHistoryForDiscontinueCancel');
            var params = {
                RelPatientMedicationIds: relPatientMedicationIds,
                VisitId: visitId
            };
            var restangular = AprimaRestangular.get();

            return restangular
                .one('patients/' + patientId + '/rxhistory/discontinue-cancel')
                .get(params)
                .finally(timing.stop);
        }

        function isRxOnPatientAllergyList(patientId, visitId, relPatientMedicationId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'isRxOnPatientAllergyList');
            var params = {
                RelPatientMedicationId: relPatientMedicationId,
                VisitId: visitId
            };
            var restangular = AprimaRestangular.get();

            return restangular
                .one('patients/' + patientId + '/rxhistory/on-patient-drug-allergy-list')
                .get(params)
                .finally(timing.stop);
        }

        function getTransitionOfCare(patientId, visitId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getTransitionOfCare');
            var restangular = AprimaRestangular.get();
            var params = {
                VisitId: visitId,
            };
            return restangular
                .one('patients/' + patientId + '/transitionofcare')
                .get(params)
                .finally(timing.stop);
        }

        function setPatientTakesNoMeds(patientId, visitId, patientTakesNoMeds) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'setPatientTakesNoMeds');
            var restangular = AprimaRestangular.get();
            var params = {
                VisitId: visitId,
            };
            return restangular
                .all('patients/' + patientId + '/patienttakesnomeds')
                .post(patientTakesNoMeds, params)
                .finally(timing.stop);
        }

        function getPatientMedicationStatus(relPatientMedicationId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getPatientMedicationStatus');
            var restangular = AprimaRestangular.get();

            var promise = restangular
                .all('history')
                .one('patient-medication-status', relPatientMedicationId)
                .get()
                .finally(timing.stop);

            return promise;
        }

        function getPatientMedicationStatuses(relPatientMedicationIdList) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getPatientMedicationStatuses');
            var restangular = AprimaRestangular.get();
           

            var promise = restangular
                .all('history')
                .all('patient-medication-status')
                .customPOST(relPatientMedicationIdList)
                .then(function(data) {
                    if(!data || !data.Results) {
                        return $q.reject('Could not retrieve medication statuses');
                    }

                    // Results is a dictionary with the key being the RelPatientMedicationUid,
                    // and the value being the med status
                    return data.Results;
                })
                .finally(timing.stop);

            return promise;
        }
        
        function setTransitionOfCare(patientId, visitId, transitionOfCare) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'setTransitionOfCare');
            var restangular = AprimaRestangular.get();
            var params = {
                VisitId: visitId,
            };
            return restangular
                .all('patients/' + patientId + '/transitionofcare')
                .post(transitionOfCare, params)
                .finally(timing.stop);
        }

        function discontinueCancelMedications(patientId, dto) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'discontinueCancelMedications');
            var restangular = AprimaRestangular.get();
            return restangular
                .all('patients/' + patientId + '/rxhistory/process-discontinue-cancel')
                .post(dto)
                .finally(timing.stop);
        }

        function getCompareInfoForDiscontinueCancel(patientId, relPatientMedicationId) {
            var timing = AprimaAnalytics.startTiming('HxMedicationRepository', 'api', 'getCompareInfoForDiscontinueCancel');
            var restangular = AprimaRestangular.get();
            return restangular
                .one('patients/' + patientId + '/rxhistory/discontinue-cancel/compare/' + relPatientMedicationId)
                .get()
                .finally(timing.stop);
        }
    }
})(angular);